import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { UpdateGroceryInput } from '@/models/grocery';

export const updateGrocery = async ({ orderId, notes, name, isConfirmedAddressAndNotes, isInteractedWithShopper }: UpdateGroceryInput) => {
  const response = await mutationExecute({
    variables: {
      orderId,
      notes,
      name,
      isConfirmedAddressAndNotes,
      isInteractedWithShopper,
    },
    mutation: graphql(`
      mutation UpdateGrocery(
        $orderId: String!
        $name: String
        $notes: String
        $isConfirmedAddressAndNotes: Boolean
        $isInteractedWithShopper: Boolean
      ) {
        updateGrocery(
          orderId: $orderId
          name: $name
          notes: $notes
          isConfirmedAddressAndNotes: $isConfirmedAddressAndNotes
          isInteractedWithShopper: $isInteractedWithShopper
        ) {
          id
          name
          orderId
          cartId
          orderUUId
          callerId
          customerName
          timeZone
          email
          address
          status
          currency
          notes
          orderNotes
          transactionId
          instruction
          userId
          orderedByName
          timeReceived
          timeShopping
          timeShoppingComplete
          timeInTransit
          timeCompleted
          timeCanceled
          chatLink
          paidStatus
          canceledBy
          canceledById
          canceledByName
          reasonForCanceling
          noGoGoFee
          noGoGoFeeReason
          tip
          totalCost
          gogoFee
          gogoCost
          discount
          isTipable
          isSavedGrocery
          assignedOperatorId
          isConfirmedAddressAndNotes
          isInteractedWithShopper
          preauthChargeAmount
          driverId
          groceryStoreId
          storeName
          storeLogo
          driverName
          initialEstimateStartAt
          initialEstimateEndAt
          estimateStartAt
          estimateEndAt
          createdAt
          updatedAt
        }
      }
    `),
  });

  return response.data?.updateGrocery;
};
